import React from 'react';
import { CardContent, Stack } from '@mui/material';
import IdentificationSection from './sections/IdentificationSection';
import LocationSection from './sections/LocationSection';
import StatusDatesSection from './sections/StatusDatesSection';
import MaintenanceScheduleSection from './sections/MaintenanceScheduleSection';
import NotesSection from './sections/NotesSection';
import AssetCostSummarySection from './sections/AssetCostSummarySection';
import DocumentUploadsSection from './sections/DocumentUploadsSection';

/**
 * AssetEditForm - Main form container for asset editing
 * Organizes all sections in a logical flow (same layout as create)
 */
export const AssetEditForm: React.FC = () => {
  return (
    <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
      <Stack spacing={2.5}>
        <IdentificationSection />
        <LocationSection />
        <StatusDatesSection />
        <MaintenanceScheduleSection />
        <AssetCostSummarySection />
        <DocumentUploadsSection />
        <NotesSection />
      </Stack>
    </CardContent>
  );
};

export default AssetEditForm;
